import { createStructuredSelector } from 'reselect';
import {
  TID_LIST, TID_LIST_SUCCESS, TID_LIST_ERROR, TID_PAGE_SET,
  TID_ADD, TID_ADD_SUCCESS, TID_ADD_ERROR,
  TID_SEARCH_CHANGE,
  TID_FILTER_TASK_STATUS, TID_FILTER_TASK_STATUS_SUCCESS,
  TID_FILTER_SUPPLIERS, TID_FILTER_SUPPLIERS_SUCCESS,
  TID_FILTER_DESTINATIONS, TID_FILTER_DESTINATIONS_SUCCESS
} from '../../actions';

export const NAME = 'task_inspection_destination';

export const TaskInspectionDestinationList = (page, num_page, orderBy, filters) => ({ type: TID_LIST, payload: { page, num_page, orderBy, filters } });
export const TaskInspectionDestinationListSuccess = (data) => ({ type: TID_LIST_SUCCESS, payload: data });
export const TaskInspectionDestinationListError = (error) => ({ type: TID_LIST_ERROR, payload: error });
export const TaskInspectionDestinationPageSet = (data) => ({ type: TID_PAGE_SET, payload: data });
export const TaskInspectionDestinationAdd = (data) => ({ type: TID_ADD, payload: data });
export const TaskInspectionDestinationAddSuccess = (data) => ({ type: TID_ADD_SUCCESS, payload: data });
export const TaskInspectionDestinationAddError = (error) => ({ type: TID_ADD_ERROR, payload: error });
export const TaskInspectionDestinationSearchChange = (data) => ({ type: TID_SEARCH_CHANGE, payload: data });
export const TaskInspectionDestinationFilterTaskStatus = () => ({ type: TID_FILTER_TASK_STATUS });
export const TaskInspectionDestinationFilterTaskStatusSuccess = (data) => ({ type: TID_FILTER_TASK_STATUS_SUCCESS, payload: data });
export const TaskInspectionDestinationFilterSuppliers = () => ({ type: TID_FILTER_SUPPLIERS });
export const TaskInspectionDestinationFilterSuppliersSuccess = (data) => ({ type: TID_FILTER_SUPPLIERS_SUCCESS, payload: data });
export const TaskInspectionDestinationFilterDestinations = () => ({ type: TID_FILTER_DESTINATIONS });
export const TaskInspectionDestinationFilterDestinationsSuccess = (data) => ({ type: TID_FILTER_DESTINATIONS_SUCCESS, payload: data });

const task_inspection_destination = (state) => state[NAME];
export const TaskInspectionDestinationSelector = createStructuredSelector({ task_inspection_destination });
